module.exports = __webpack_public_path__ + "img/layout-1.958c91de.svg";